angular
.module('app.views')
.controller('BoxcastersNewMfgController', function($scope, $routeParams, $modalInstance, Boxcaster, Manufacturer){
  $scope.isCreating = false;
  $scope.manufacturerId = null;
  $scope.count = 1;
  $scope.prefix = "o";
  $scope.manufacturerAccountId = null;
  $scope.manufacturers = Manufacturer.query((data) => {
    $scope.manufacturerId = data[0].id;
    $scope.manufacturerAccountId = data[0].account_id;
  });

  $scope.updateMfgAccount = () => { $scope.manufacturerAccountId = _.find($scope.manufacturers, m => m.id === $scope.manufacturerId).account_id; }

  $scope.ok = function() {
    $scope.isCreating = true;
    Boxcaster.createBatch({count: $scope.count, prefix: $scope.prefix, manufacturer_id: $scope.manufacturerId}, (data) => {
      // Okay... got the data -- format, convert to CSV, and download
      var csvStr = 'serial_num,mac_id,barcode_num\n';
      csvStr += data.map((boxcaster) => {
        var macId = boxcaster.id.substring(1).toUpperCase().replace(/(.{2})/g, "$1-").slice(0, -1);
        return `${boxcaster.id},${macId},${boxcaster.id}`;
      }).join('\n');
      const downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURIComponent(csvStr)}`);
      downloadAnchorNode.setAttribute("download", "boxcasters.csv");
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
      return $modalInstance.close($scope.manufacturerAccountId);
    }, (err) => {
      alert('There was an error creating the BoxCasters.');
    });

    $scope.isCreating = false;
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/boxcasters/boxcasters_new_mfg_controller.js